import { DragOverlay, defaultDropAnimationSideEffects } from "@dnd-kit/core";
import { createElement } from "react";

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0.4",
      },
    },
  }),
};

export function SortableOverlay({ children }) {
  return createElement(
    DragOverlay,
    { dropAnimation: dropAnimationConfig },
    children,
  );
}
